export default __webpack_public_path__ + "static/media/cobertura_ecuador_mega_menu.8416c4ba.jpg";